import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import Onboarding from "@/components/Onboarding";
import { api } from "@/lib/api";

export default function Layout() {
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("synchub_onboarding_done");
    if (dismissed) return;
    api.get("/settings").then(({ data }) => {
      if (!data?.qoyod_api_key || !data?.salla_client_id) {
        setShowOnboarding(true);
      }
    }).catch(() => {});
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("synchub_onboarding_done", "1");
    setShowOnboarding(false);
  };

  return (
    <div className="h-screen flex overflow-hidden bg-[var(--bg-page)] transition-colors duration-300" dir="rtl">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
        <TopBar />
        <main className="flex-1 overflow-y-auto overflow-x-hidden pt-14 md:pt-0 bg-[var(--bg-page)] transition-colors duration-300">
          <Outlet />
        </main>
      </div>
      {showOnboarding && <Onboarding onDismiss={handleDismiss} />}
    </div>
  );
}
